var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("crear-persona"),
      _vm._v(" "),
      _c("editar-persona"),
      _vm._v(" "),
      _c("aprobar-movilidad"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("business")]),
          _vm._v(" Lista de servidores públicos")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "crud-table",
                {
                  attrs: {
                    headers: _vm.headers,
                    url: _vm.url,
                    filters: _vm.filters,
                    "data-graphql": _vm.dataGraphql,
                    graphql: _vm.graphql
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(items) {
                        return [
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(_vm._s(items.item.nro_doc))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(_vm._s(items.item.item))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(_vm._s(items.item.nombre))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(_vm._s(items.item.unidad))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(_vm._s(items.item.fecha_ingreso))
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-center" },
                            [
                              items.item.id_estado === 1
                                ? _c(
                                    "v-chip",
                                    {
                                      attrs: {
                                        color: "success",
                                        "text-color": "white"
                                      }
                                    },
                                    [_vm._v(_vm._s(items.item.estado))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              items.item.id_estado === 32
                                ? _c(
                                    "v-chip",
                                    {
                                      attrs: {
                                        color: "error",
                                        "text-color": "white"
                                      }
                                    },
                                    [_vm._v(_vm._s(items.item.estado))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              items.item.id_estado === 2
                                ? _c(
                                    "v-chip",
                                    {
                                      attrs: {
                                        color: "error",
                                        "text-color": "white"
                                      }
                                    },
                                    [_vm._v(_vm._s(items.item.estado))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              items.item.id_estado === 5
                                ? _c(
                                    "v-chip",
                                    {
                                      attrs: {
                                        color: "orange",
                                        "text-color": "white"
                                      }
                                    },
                                    [_vm._v(_vm._s(items.item.estado))]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-center" },
                            [
                              items.item.id_estado === 1
                                ? _c(
                                    "v-tooltip",
                                    { attrs: { bottom: "" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            slot: "activator",
                                            color: "red",
                                            dark: "",
                                            icon: ""
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.editarPersona(
                                                items.item
                                              )
                                            }
                                          },
                                          slot: "activator"
                                        },
                                        [_c("v-icon", [_vm._v("edit")])],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Editar")])
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              items.item.id_estado === 1
                                ? _c(
                                    "v-tooltip",
                                    { attrs: { bottom: "" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            slot: "activator",
                                            color: "green",
                                            dark: "",
                                            icon: "",
                                            to:
                                              "personas/ficha-personal/" +
                                              items.item.id_persona
                                          },
                                          slot: "activator"
                                        },
                                        [_c("v-icon", [_vm._v("note")])],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Ficha personal")])
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              items.item.id_estado === 1
                                ? _c(
                                    "v-tooltip",
                                    { attrs: { bottom: "" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            slot: "activator",
                                            color: "blue",
                                            dark: "",
                                            to:
                                              "movilidad/" +
                                              items.item.id_persona,
                                            icon: ""
                                          },
                                          slot: "activator"
                                        },
                                        [_c("v-icon", [_vm._v("refresh")])],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Movilidad")])
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              items.item.id_estado === 5
                                ? _c(
                                    "v-tooltip",
                                    { attrs: { bottom: "" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            slot: "activator",
                                            color: "orange",
                                            dark: "",
                                            icon: ""
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.aprobarMovilidad(
                                                items.item
                                              )
                                            }
                                          },
                                          slot: "activator"
                                        },
                                        [_c("v-icon", [_vm._v("check")])],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Aprobar")])
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c(
                    "template",
                    { slot: "buttons" },
                    [
                      _c(
                        "v-tooltip",
                        { attrs: { bottom: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                slot: "activator",
                                color: "primary",
                                dark: ""
                              },
                              nativeOn: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.crearPersona()
                                }
                              },
                              slot: "activator"
                            },
                            [
                              _c("v-icon", { attrs: { dark: "" } }, [
                                _vm._v("add")
                              ]),
                              _vm._v(" " + _vm._s(_vm.$t("common.add")))
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v("Agregar persona")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { width: "400", persistent: "" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { color: "#385F73", dark: "" } },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        [
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _c("p", { attrs: { color: "red" } }, [
                                  _vm._v(_vm._s(_vm.respuestaFuncion[0]))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("v-list-tile-title", [
                                _c("p", [
                                  _vm._v(_vm._s(_vm.respuestaFuncion[1]))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("v-list-tile-title", [
                                _c("p", [
                                  _vm._v(_vm._s(_vm.respuestaFuncion[2]))
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "success" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("\n          clear\n        ")]),
                      _vm._v("\n        Cerrar\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-697b4ad3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-697b4ad3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/persona/Index2.vue
// module id = null
// module chunks = 